import React from 'react'
import classnames from 'classnames'
import { Spinner } from '@components/Spinner/Spinner'

import { FlowCard } from './FlowCard'

type Props = React.HTMLAttributes<HTMLDivElement>

export const FlowCardLoading: React.FC<Props> = props => {
  const { className, children, ...rest } = props
  const classes = classnames('flex h-full items-center', className)

  return (
    <FlowCard>
      <div className={classes} {...rest}>
        <Spinner />
      </div>
    </FlowCard>
  )
}
